/**
 * Balance Engine — weight distribution, rhythm, and contrast intent.
 *
 * Symmetry is a mood statement: centered symmetry reads calm and premium,
 * asymmetry reads dynamic. Rhythm describes the spacing cadence between
 * objects; contrast states how hard adjacent hierarchy levels should
 * differ. All intent, no geometry.
 */

/**
 * Build balance intent from mood + flow.
 * Returns { symmetry, weightDistribution, rhythm, contrastLevel, tension }.
 */
export const planBalance = ({ mood, flow }) => {
  const symmetric = flow.id === 'center-focus' || flow.id === 'circular';

  return {
    symmetry: symmetric ? 'symmetric' : 'asymmetric',
    // Which side carries the visual mass. Symmetric designs center it;
    // directional flows load the side the path starts from.
    weightDistribution: symmetric
      ? 'centered'
      : flow.id === 'left-focus' ? 'left-heavy'
      : flow.id === 'right-focus' ? 'right-heavy'
      : 'top-heavy',
    // Spacing cadence: regular = even gaps (calm), syncopated = varied
    // gaps (energetic). High-energy briefs earn syncopation.
    rhythm: mood.energy >= 0.65 ? 'syncopated' : 'regular',
    contrastLevel: mood.contrast,
    // How much deliberate imbalance the design tolerates before it must
    // be resolved by a counterweight (decoration or whitespace).
    tension: Number((mood.energy * 0.6 + (symmetric ? 0 : 0.25)).toFixed(2)),
  };
};
